import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { WorkflowStep } from '../types/disclosures';
const steps: {
  id: WorkflowStep;
  label: string;
}[] = [{
  id: 'review',
  label: 'Review'
}, {
  id: 'generate',
  label: 'Generate'
}, {
  id: 'send',
  label: 'Send'
}];
interface StepIndicatorProps {
  currentStep: WorkflowStep;
  completed: boolean;
}
export function StepIndicator({
  currentStep,
  completed
}: StepIndicatorProps) {
  const currentIndex = steps.findIndex(step => step.id === currentStep);
  return <nav aria-label="Disclosure progress" className="mb-5" data-id="element-393" data-mp="e45uyw03of8o">
      <ol className="flex items-center gap-2" data-id="element-394" data-mp="3vjm2d2pjbe4j">
        {steps.map((step, index) => {
        const isDone = completed || index < currentIndex;
        const isCurrent = !completed && index === currentIndex;
        return <li key={step.id} className="flex flex-1 items-center gap-2" data-id="element-395" data-mp="3mjz1qj4mqccj" data-mpi={index}>
              <span className={`flex items-center gap-2 text-[13px] font-medium ${isCurrent ? 'text-slate-900' : isDone ? 'text-slate-600' : 'text-slate-400'}`} aria-current={isCurrent ? 'step' : undefined} data-id="element-396" data-mp="3qk9golaegd3j">
                <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-semibold ring-1 ${isDone ? 'bg-emerald-500 text-white ring-emerald-500' : isCurrent ? 'bg-slate-900 text-white ring-slate-900' : 'bg-white text-slate-400 ring-slate-200'}`} data-id="element-397" data-mp="bqc7nzk0b5bm">
                  {isDone ? <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-398" data-mp="3oygnbf197yk6" /> : index + 1}
                </span>
                {step.label}
              </span>
              {index < steps.length - 1 && <span aria-hidden="true" className={`h-px flex-1 ${isDone ? 'bg-emerald-200' : 'bg-slate-200'}`} data-id="element-399" data-mp="2wf9wridsnnly" />}
            </li>;
      })}
      </ol>
    </nav>;
}